import CollectionUpdate from "./collection-update";

export default CollectionUpdate;